import script from "./FilmCutForm.vue?vue&type=script&setup=true&lang=js"
export * from "./FilmCutForm.vue?vue&type=script&setup=true&lang=js"

import "./FilmCutForm.vue?vue&type=style&index=0&id=56c8ac16&lang=scss"

const __exports__ = script;

export default __exports__